import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ListViewFilterItem } from '../../model/list-view';

@Component({
  selector: 'zx-list-view-filter',
  templateUrl: './list-view-filter.component.html',
  styleUrls: [ './list-view-filter.component.css' ],
})
export class ListViewFilterComponent implements OnInit {

  private _savedState = [];
  private _restoreState = true;
	private _dictData: ListViewFilterItem[];
  
  constructor() { }
  ngOnInit(){ }

  @Output() valueChange: EventEmitter<any> = new EventEmitter();

	@Input() set filterItems(v: ListViewFilterItem[]) { 
		this._dictData = (v ? v : []); 
    this._dictData.forEach(item => {
      if(!item.text && item.value) item.text = item.value.toString(); 
    });
		this._dictData.sort((a,b) => a.seq > b.seq ? 1:-1);
	}
  get filterItems(): ListViewFilterItem[] { return this._dictData; }


  get result() {
  	return this._dictData.filter(item => item.selected).map(item => item.value);
  }

  confirm() {
    this.restoreState(false);
  	this.valueChange.emit(this.result);
  }
  reset() {
    this.restoreState(false);
  	this._dictData.every(item => {item.selected = false; return true;});
  	this.valueChange.emit([]);
  }

  restoreState(restore?: boolean){
    if(restore != null) this._restoreState = restore;
    if(this._restoreState){
      this._dictData.forEach(item => {item.selected = false;});
      this._savedState.forEach(item => {item.selected = true;});
      this._restoreState = false;
    }
    this._savedState = [];
  }
  saveState(){
    this._savedState = this._dictData.filter(item => item.selected);
    this._restoreState = true;
  }

  onVisibleChange(visible){
    if(visible) this.saveState();
    else this.restoreState();
  }
}